import { useMemo } from 'react';
import { InjectedFormProps, reduxForm } from 'redux-form';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import FormGroup from 'dashboard/components/FormGroup';
import Button from 'design-system/components/Button';
import FormControlField from 'lib/interfaces/FormControlField';
import {
  areValuesMatching,
  isMaxLength,
  isPasswordStrong,
  isRequired,
  withMessage,
} from 'lib/utils/formValidation';

const ButtonContainer = styled('div')`
  display: flex;
`;

const FormUpdatePassword = ({ handleSubmit, submitting, pristine }: InjectedFormProps) => {
  const validate = useMemo(() => {
    return {
      password: [
        withMessage('Please enter a new password', isRequired),
        withMessage(
          'Provided passwords must match',
          areValuesMatching(['password', 'passwordConfirmation']),
        ),
        // NB: username hard-coded because we don't expose it in the password reset flow
        // to prevent leaking
        withMessage('Please enter a stronger password', isPasswordStrong('username')),
        withMessage('Please limit password to 50 characters.', isMaxLength(50)),
      ],
    };
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <FormGroup>
        <label htmlFor='password'>New password</label>
        <FormControlField
          component={InputField}
          name='password'
          id='password'
          type='password'
          validate={validate.password}
          disabled={submitting}
          placeholder='New password'
        />
      </FormGroup>
      <FormGroup>
        <label htmlFor='passwordConfirmation'>Confirm new password</label>
        <FormControlField
          component={InputField}
          name='passwordConfirmation'
          id='passwordConfirmation'
          type='password'
          validate={validate.password}
          disabled={submitting}
          placeholder='Confirm new password'
        />
      </FormGroup>
      <ButtonContainer>
        <Button type='submit' disabled={submitting || pristine} isPending={submitting}>
          Update password
        </Button>
      </ButtonContainer>
    </form>
  );
};

export default reduxForm({
  form: 'updatePassword',
})(FormUpdatePassword);
